import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled, { css } from 'styled-components';

import { getMedia, getMediaMin, percent } from '../../../helpers/layout';
import Television from '../Television/Television';

export const Title = styled.h2`
    ${FONTS.H1};
    color: #F2F2F2;

    @media only screen and ${getMedia('desktop', 'phone')} {
        ${FONTS.H2};
    }

    @media only screen and ${getMedia('phone')} {
        ${FONTS.H3};
    }
`;

export const Text = styled.p`
    ${FONTS.S};
    color: #F2F2F2;
    margin-top: 15px;
    max-width: 83%;

    @media only screen and ${getMedia('tablet', 'phone')} {
        margin-top: 19px;
        margin-left: auto;
        margin-right: auto;
    }

    @media only screen and ${getMedia('phone')} {
        max-width: none;
    }
`;

export const Content = styled.div`
    position: relative;
    z-index: 11;
    display: block;
    margin-left: auto;
    max-width: ${percent(1920, 450)}vw;
    align-self: center;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        max-width: ${percent(1366, 395)}vw;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        max-width: ${percent(768, 555)}vw;
    }

    @media only screen and ${getMedia('phone')} {
        margin-left: 0;
        max-width: none;
    }

    @media only screen and (max-aspect-ratio: 4/3) and ${getMediaMin('tablet')} {
        max-width: 80%;
        margin-left: 0;
        padding-bottom: 30vh;
    }
`;

export const TelevisionStyled = styled(Television)`
    position: absolute;
    bottom: -5.4vw;
    right: 0;
    z-index: 10;
    transform-origin: center;
    transform: translateX(64%) translateX(-74.9vw) translateY(-1.3%);

    @media only screen and ${getMedia('desktop', 'tablet')} {
        bottom: -5.5vw;
        transform: translateX(64%) translateX(-73.5vw) translateY(-2.1%);
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        bottom: -7.4vw;
        transform: translateX(8.6%);
    }

    @media only screen and ${getMedia('phone')} {
        bottom: 0.5vw;
        transform: translateX(21.3%);
    }
`;

export const Label = styled.span`
    position: absolute;
    right: 73px;
    ${FONTS.XXS};
    color: #828282;
    max-width: 100%;
    bottom: 30px;
    z-index: 11;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        right: 44px;
        bottom: 21px;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        right: 60px;
        left: 60px;
        bottom: ${percent(768, 24)}vw;
    }

    @media only screen and ${getMedia('phone')} {
        right: 20px;
        left: 20px;
        bottom: ${percent(320, 25)}vw;
        ${FONTS.XS};
    }
`;

export const Section = styled.section`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(0deg, #272A2C 46.74%, #252729 98.96%);
    overflow: hidden;
    display: flex;
    padding: 145px 168px 84px;
    will-change: opacity;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        padding: 54px 79px 18px;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        display: block;
        position: relative;
        padding: 213px 62px ${percent(768, 647)}vw;
        height: auto;
    }

    @media only screen and ${getMedia('phone')} {
        display: block;
        position: relative;
        height: auto;
        padding: 116px 20px ${percent(320, 380)}vw;
    }

    @media only screen and (max-aspect-ratio: 4/3) and ${getMediaMin('tablet')} {
        display: flex;
    }

    @media only screen and ${getMediaMin('tablet')} {
        ${({ isActive, from, to }) => {
            // Переход на первый слайд
            if (!isActive && to === 'main') {
                return css`
                    opacity: 0;
                    transition: opacity 0s ease-out 1.4s;

                    ${TelevisionStyled} {
                        transform: scale(0.866) translateX(45.07%);
                        transition: transform 0.8s cubic-bezier(.58,.06,.31,.79);

                        @media only screen and ${getMedia('desktop', 'tablet')} {
                            transform: scale(0.87) translateX(41.9%);
                        }
                    }

                    ${Title},
                    ${Text} {
                        opacity: 0;
                        transform: translateY(45px);
                        transition: opacity 0.3s ease-out, transform 0.3s ease-out;
                    }
                `;
            } else if (!isActive && to === 'advantage') { // Переход на второй слайд
                return css`
                    opacity: 0;
                    transition: opacity 0s ease-out 1.4s;

                    ${TelevisionStyled} {
                        transform: scale(0.866) translateX(64%) translateX(-58.1vw);
                        transition: transform 0.8s cubic-bezier(.58,.06,.31,.79);

                        @media only screen and ${getMedia('desktop', 'tablet')} {
                            transform: scale(0.87) translateX(66%) translateX(-57.8vw);
                        }
                    }

                    ${Title},
                    ${Text} {
                        opacity: 0;
                        transform: translateY(45px);
                        transition: opacity 0.3s ease-out, transform 0.3s ease-out;
                    }
                `;
            } else if (isActive && (from === 'main' || from === 'advantage')) { // Приход с первого экрана
                return css`
                    transition: opacity 0.4s ease-out 0.8s;
                    opacity: 1;
                    z-index: 10;

                    ${Title},
                    ${Text} {
                        opacity: 1;
                        transform: translateY(0);
                    }

                    ${Title} {
                        transition: opacity 0.3s ease-out 0.8s, transform 0.3s ease-out 0.8s;
                    }

                    ${Text} {
                        transition: opacity 0.3s ease-out 1.1s, transform 0.3s ease-out 1.1s;
                    }
                `;
            } else if (isActive) {
                return css`
                    transition: opacity 0.4s ease-out;
                    opacity: 1;
                    z-index: 10;

                    ${Title},
                    ${Text} {
                        opacity: 1;
                        transform: translateY(0);
                    }

                    ${Title} {
                        transition: opacity 0.3s ease-out 0.4s, transform 0.3s ease-out 0.4s;
                    }

                    ${Text} {
                        transition: opacity 0.3s ease-out 0.7s, transform 0.3s ease-out 0.7s;
                    }
                `;
            } else {
                return css`
                    opacity: 0;
                    transition: opacity 0.4s ease-out 0.4s;

                    ${Title},
                    ${Text} {
                        opacity: 0;
                        transform: translateY(45px);
                        transition: opacity 0.3s ease-out 0.4s, transform 0.3s ease-out 0.4s;
                    }
                `;
            }
        }}
    }

    &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: ${percent(1920, 466)}vw;
        background: linear-gradient(0.07deg, #363C45 0.25%, #373C44 14.53%, #373C44 20.61%, #292D34 38.39%, #272C32 50.77%, #2A2E32 71.79%, #25282A 83.88%, #272A2C 110.32%);
        z-index: 1;

        @media only screen and ${getMedia('tablet', 'phone')} {
            height: ${percent(768, 330)}vw;
        }

        @media only screen and ${getMedia('phone')} {
            height: ${percent(320, 258)}vw;
        }
    }
`;
